import { render, staticRenderFns } from "./header.vue?vue&type=template&id=fac4690c&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=fac4690c&prod&lang=css"
import style1 from "./header.vue?vue&type=style&index=1&id=fac4690c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac4690c",
  null
  
)

export default component.exports